import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import globals from '@/plugins/globals.js'

export default {
  resetServiceRequest({ commit }) {
    commit(types.RESET_SERVICE_REQUEST)
  },
  setHubData({ commit }, data) {
    commit(types.SET_HUB_DATA, data)
  },
  setStatisticInterval({ commit }, interval) {
    commit(types.SET_INTERVAL, interval)
  },
  setConnectedDevices({ commit }, devices) {
    commit(types.SET_CONNECTED_DEVICES, devices)
  },
  setTools({ commit }, data) {
    commit(types.RESET_TOOLS, data)
  },
  setChatStatus({ commit }, channel) {
    commit(types.SET_CHAT_STATUS, channel)
  },
  setEditStatus({ commit }, action) {
    commit(types.SET_EDIT_STATUS, action)
  },
  async getTools({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getTools', () =>
      http.get('dispatch/GetTools')
    )
    commit(types.SET_TOOLS, r.data)
    return r.data
  },
  async getMonitorInfo({ commit, dispatch }, data) {
    data.appId = globals.getApp()
    const r = await startLoading(dispatch, 'getMonitorInfo', () =>
      http.get(`device/GetMonitorInfo`, {
        params: data
      })
    )
    commit(types.SET_MONITOR_INFO, r.data)
    return r.data
  },
  async getPairingInfo({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPairingInfo', () =>
      http.get(`device/GetDevicePairInfo`, {
        params: data
      })
    )
    commit(types.SET_PAIRING_INFO, r.data)
    return r.data
  },
  async getServiceRequest({ commit, dispatch }, id) {
    if (id !== undefined && id !== null) {
      const r = await startLoading(dispatch, 'getServiceRequest', () =>
        http.get(`servicerequest/ServiceRequestSummary?id=${id}`)
      )
      commit(types.SET_SERVICE_REQUEST, r.data)
      return r.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/actions.js